<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <form role="form" @submit.prevent>
          <h6 class="heading-small text-muted mb-4">Report Type</h6>
          <div>
            <div class="row mb-3">
              <div class="col">
                <a-select
                  v-model="table.appendedParams.report_type"
                  style="width: 100%"
                  placeholder="Select Report"
                  :filter-option="filterOption"
                  @change="onChangeReportType"
                >
                  <a-select-option value="assignedCards" key="assignedCards">
                    Assigned Cards for Today
                  </a-select-option>
                  <a-select-option value="receivedCount" key="receivedCount">
                    Received Count (On-hand)
                  </a-select-option>
                  <a-select-option value="receivedList" key="receivedList">
                    Received List (On-hand)
                  </a-select-option>
                  <a-select-option
                    value="cardSellingSales"
                    key="cardSellingSales"
                  >
                    Card Selling Cash Sales for Today
                  </a-select-option>
                  <a-select-option
                    value="cardSellingTransactions"
                    key="cardSellingTransactions"
                  >
                    Card Selling Other Tenders for Today
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </form>
      </template>

      <template #pageTable>
        <PageTable
          :key="tableKey"
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.appendedParams"
          :displayfooterNotes="table.displayfooterNotes"
          @doneLoading="generateAmountTotal"
        >
          <template #headerButtons>
            <div>
              <b-button
                v-if="
                  selectedActions.includes('Download') ||
                  selectedActions.includes('Send')
                "
                variant="danger"
                @click.prevent="openDrawer('export_data')"
                >Export</b-button
              >
            </div>
          </template>
          <template #footerNotes>
            <h6 class="heading-small text-muted mb-4">
              {{ table.footerNote }}
            </h6>
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <ExportDataForm
                v-if="drawer.action == 'export_data'"
                :jsonFields="toJsonFields"
                :apiUrl="tableApiUrl"
                :filename="filename"
                :reportType="table.appendedParams.report_type"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../../components/Page/Header.vue';
import PageContent from '../../../components/Page/Content.vue';
import PageTable from '../../../components/Page/Table.vue';
import ExportDataForm from '../Drawers/ExportDataForm.vue';
import { mapGetters } from 'vuex';
import secureStorage from '../../../controllers/secureStorage';

import moment from 'moment';

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    ExportDataForm
  },
  data() {
    return {
      filename: `Report - ${moment().format('YYYY-MM-DDTHHmmss.SSS')}.csv`,
      // baseUrl: "https://di0885fdgb.execute-api.ap-southeast-1.amazonaws.com/dev/cardListing",
      baseUrl: process.env.VUE_APP_PRG_TEMP_REPORT_API,
      tableKey: 0,
      gradientType: 'gradient-yellow',
      accountReport: null,
      drawer: {
        visible: false,
        width: 600,
        placement: 'right',
        action: null
      },
      table: {
        title: 'PRG Card Reports',
        // apiUrl: 'https://di0885fdgb.execute-api.ap-southeast-1.amazonaws.com/dev/cardListing?siteId=' + secureStorage.getItem('currentSiteId') ,
        apiUrl: process.env.VUE_APP_PRG_TEMP_REPORT_API + '/cardListing',
        fields: [
          'Site Name',
          'Card Type',
          'Card Number',
          'Serial Number',
          'Status',
          'Date'
        ],
        appendedParams: {
          report_type: 'assignedCards',
          export_data: false,
          cardStatusId: 4,
          siteId: secureStorage.getItem('currentSiteId')
        },
        multiSort: true,
        multiSortKey: 'alt',
        sortOrder: null,
        footerNote: '',
        displayfooterNotes: false
      }
    };
  },
  methods: {
    generateAmountTotal(data) {
      let valueKey = 'price_quantity';
      if (this.table.appendedParams.report_type == 'cardSellingTransactions') {
        valueKey = 'amount';
      }
      const rows = data.data;
      const total = rows.reduce((acc, row) => acc + row[valueKey], 0);
      this.table.footerNote = `Total Amount(Calculated): ${total}`;
    },
    filterOption(inputValue, option) {
      return (
        option?.componentOptions?.propsData?.label
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) !== -1
      );
    },
    async getAccountReportData() {
      this.table.apiUrl =
        process.env.VUE_APP_PRG_TEMP_REPORT_API + '/cardListing';

      switch (this.table.appendedParams.report_type) {
        case 'assignedCards':
          this.table.appendedParams.cardStatusId = 4;
          this.table.fields = [
            'Site Name',
            'Card Type',
            'Card Number',
            'Serial Number',
            'Status',
            'Date'
          ];
          break;

        case 'receivedCount':
          this.table.appendedParams.cardStatusId = 2;
          this.table.fields = ['Site Name', 'Card Type', 'Count'];
          break;

        case 'receivedList':
          this.table.appendedParams.cardStatusId = 0;
          this.table.fields = [
            'Site Name',
            'Card Type',
            'Card Number',
            'Serial Number',
            'Status'
          ];
          break;

        case 'cardSellingSales':
          this.table.apiUrl =
            process.env.VUE_APP_PRG_TEMP_REPORT_API + '/card_selling/sales';
          this.table.appendedParams.cardStatusId = 0;

          this.table.fields = [
            { name: 'card_selling_type_name', title: 'Item' },

            { name: 'transaction_count', title: 'Quantity' },
            { name: 'price', title: 'Rate' },
            { name: 'price_quantity', title: 'Amount' },
            { name: 'site_code', title: 'Site Code' },
            {
              name: 'transaction_date',
              title: 'Date',
              formatter(value) {
                return moment(value).format('MM/DD/YYYY');
              }
            }
          ];
          break;

        case 'cardSellingTransactions':
          this.table.apiUrl =
            process.env.VUE_APP_PRG_TEMP_REPORT_API +
            '/card_selling/transactions';
          this.table.appendedParams.cardStatusId = 0;

          this.table.fields = [
            { name: 'site_code', title: 'Site Code' },
            {
              name: 'transaction_date',
              title: 'Date',
              formatter(value) {
                return moment(value).format('MM/DD/YYYY');
              }
            },
            { name: 'payment_name', title: 'Payment Name' },
            { name: 'amount', title: 'Payment Amount' },
            // { name: 'trans_id', title: 'Transaction Number' },
            { name: 'remarks', title: 'Payment Remarks' }
          ];
          break;
      }

      this.tableKey++;
    },

    async onChangeReportType() {
      /** Get report data for the report type */
      this.getAccountReportData();
    },

    serializeQuery(params, prefix) {
      const query = Object.keys(params).map((key) => {
        const value = params[key];

        if (params.constructor === Array) {
          key = `${prefix}[]`;
        } else if (params.constructor === Object) {
          key = prefix ? `${prefix}[${key}]` : key;
        }

        if (typeof value === 'object') {
          return this.serializeQuery(value, key);
        } else {
          return `${key}=${encodeURIComponent(value)}`;
        }
      });

      let serializedQuery = query.filter((elem) => elem != '');

      return [].concat.apply([], serializedQuery).join('&');
    },

    openDrawer(action) {
      this.drawer.visible = true;
      this.drawer.action = action;
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.drawer.action = null;
    }
  },
  created() {
    this.$store.dispatch('setCurrentModule', 'CardReport');
    // this.getAccountReportData();
  },
  watch: {
    'table.appendedParams.report_type': function (value) {
      if (value == 'cardSellingSales' || value == 'cardSellingTransactions') {
        this.table.displayfooterNotes = true;
      } else {
        this.table.footerNote = '';
        this.table.displayfooterNotes = false;
      }
    },
    inHeadOffice: function () {
      if (this.inHeadOffice) {
        this.options.sites = secureStorage.getItem('visitingSites');
      } else {
        this.options.sites = [secureStorage.getItem('currentSite')];
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions',
      headOfficeId: 'getHeadOffice'
    }),
    inHeadOffice() {
      return secureStorage.getItem('currentSiteId') == this.headOfficeId
        ? true
        : false;
    },
    tableApiUrl() {
      const tableApiUrl = this.table.apiUrl;
      let _tableParams = { ...this.table.appendedParams };

      console.log(_tableParams);
      _tableParams.export_data = true; // Update to true, for exportable data
      let filters;

      /** Parse object for query string */
      filters = this.serializeQuery(_tableParams);
      console.log('TABLE API URL');
      console.log(tableApiUrl + '?' + filters);

      return tableApiUrl + '?' + filters;
    },

    toJsonFields: function () {
      const _tableFields = [...this.table.fields];
      let jsonFields = {};

      for (let field of _tableFields) {
        if (typeof field.title !== 'undefined') {
          jsonFields[field.title] = field.name;
        } else {
          jsonFields[field] = field;
        }
      }

      return jsonFields;
    }
  }
};
</script>

<style scoped></style>
